var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-slicer-bar",style:({
    backgroundColor: _vm.$$FormData.background_color,
    height: _vm.$$FormData.height + 'px'
  })},[_c('div',{staticClass:"title-slicer-bar__inner",style:({'--icon-img': ("url(" + (_vm.$$FormData.slicer_icon.src) + ")")})},[_c('h3',{staticClass:"title-slicer-bar__text",style:({color: _vm.$$FormData.title_font_color})},[_vm._v(_vm._s(_vm.$$FormData.title))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ebcd94","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Decors/TitleSlicerBar/TitleSlicerBarPreview.vue
// module id = null
// module chunks = 